/* EYS header: sticky behaviour, mega menus, mobile drawer, predictive search, basket total */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 1200px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

  var money = function (cents) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format((cents || 0) / 100);
    } catch (e) {
      return '£' + ((cents || 0) / 100).toFixed(2);
    }
  };

  var store = {
    get: function (key, fallback) {
      try { var v = window.localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
    },
    set: function (key, value) {
      try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ }
    }
  };

  var escapeHtml = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* ---------- Basket: header count/total + shared refresh helper ---------- */
  var Cart = {
    _timer: null,
    updateHeader: function (cart) {
      document.querySelectorAll('[data-eys-cart-total]').forEach(function (el) {
        el.textContent = cart.item_count > 0 ? money(cart.total_price) : 'Basket';
      });
      document.querySelectorAll('.eys-badge[data-cart-organizer-bubble]').forEach(function (el) {
        var before = el.textContent.trim();
        el.textContent = cart.item_count;
        el.classList.toggle('visually-hidden', cart.item_count < 1);
        if (String(cart.item_count) !== before && cart.item_count > 0 && !REDUCED.matches) {
          el.classList.remove('eys-bump');
          void el.offsetWidth;
          el.classList.add('eys-bump');
        }
      });
    },
    sync: function () {
      clearTimeout(Cart._timer);
      Cart._timer = setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            Cart.updateHeader(cart);
            document.dispatchEvent(new CustomEvent('eys:cart-synced', { detail: cart }));
          })
          .catch(function () {});
      }, 120);
    },
    isOpen: function () {
      var modal = document.querySelector('.modal-component--cart-drawer');
      return !!modal && window.getComputedStyle(modal).display !== 'none';
    },
    open: function () {
      if (Cart.isOpen()) return;
      var opener = document.querySelector('[data-eys-cart-opener]') ||
        document.querySelector('button[data-modal-ref="modal-cart-drawer"][data-expanded="false"]');
      if (opener) opener.click();
    },
    /* Re-render the drawer contents and theme bubbles after a cart change made outside the theme JS */
    refresh: function (options) {
      var opts = options || {};
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(root + '?sections=cart-head,cart-inventory-organizer', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var parser = new DOMParser();
          if (sections['cart-inventory-organizer']) {
            var doc = parser.parseFromString(sections['cart-inventory-organizer'], 'text/html');
            var fresh = doc.querySelector('#cart-items');
            var current = document.querySelector('#cart-items');
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          }
          if (sections['cart-head']) {
            var head = parser.parseFromString(sections['cart-head'], 'text/html');
            ['[data-render-util-cart-bubble]', '[data-render-cart-bubble]', '[data-render-sticky-cart-bubble]'].forEach(function (sel) {
              var src = head.querySelector(sel);
              if (!src) return;
              document.querySelectorAll(sel).forEach(function (el) { el.innerHTML = src.innerHTML; });
            });
          }
          Cart.sync();
          if (opts.open) Cart.open();
        });
    }
  };

  /* Watch theme cart requests so the header total stays in step with every add/change */
  if (window.fetch && !window.__eysFetchPatched) {
    window.__eysFetchPatched = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function () { Cart.sync(); }).catch(function () {});
      }
      return p;
    };
  }

  window.EYS = window.EYS || {};
  window.EYS.money = money;
  window.EYS.cart = Cart;

  /* ---------- Header ---------- */
  class EysHeader extends HTMLElement {
    connectedCallback() {
      this.wrap = this.closest('.shopify-section') || this.parentElement;
      this.bar = this.querySelector('[data-eys-bar]');
      this.usp = this.querySelector('[data-eys-usp]');
      this.scrim = this.querySelector('[data-eys-scrim]');
      this.sticky = this.dataset.sticky || 'none';
      this.lastY = window.scrollY;
      this.openItem = null;

      if (this.wrap) this.wrap.classList.add('eys-sticky-wrap');

      this.portal = this.querySelector('[data-eys-portal]');
      if (this.portal) document.body.appendChild(this.portal);
      this.drawer = this.portal && this.portal.querySelector('[data-eys-drawer]');
      this.drawerScrim = this.portal && this.portal.querySelector('[data-eys-drawer-scrim]');

      this.measure = this.measure.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onKey = this.onKey.bind(this);

      this.measure();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.measure);
        this.ro.observe(this);
      }
      window.addEventListener('resize', this.measure, { passive: true });
      if (this.sticky !== 'none') window.addEventListener('scroll', this.onScroll, { passive: true });
      document.addEventListener('keydown', this.onKey);

      this.initMega();
      this.initFit();
      this.initDrawer();
      this.initUsp();

      if (this.scrim) this.scrim.addEventListener('click', () => { this.closeMega(); this.dispatchEvent(new CustomEvent('eys:scrim-click', { bubbles: true })); });
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.fitRo) this.fitRo.disconnect();
      window.removeEventListener('resize', this.measure);
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKey);
      if (this.portal && this.portal.parentNode) this.portal.parentNode.removeChild(this.portal);
      clearInterval(this.uspTimer);
      document.documentElement.classList.remove('eys-lock', 'eys-drawer-open');
    }

    measure() {
      var uspH = this.usp ? this.usp.offsetHeight : 0;
      var barH = this.bar ? this.bar.offsetHeight : 0;
      this.uspH = uspH;
      this.barH = barH;
      if (this.wrap) this.wrap.style.setProperty('--eys-usp-h', uspH + 'px');
      document.documentElement.style.setProperty('--eys-header-h', barH + 'px');
      this.updatePageHeaderVar();
      if (DESKTOP.matches && this.drawer && !this.drawer.hidden) this.closeDrawer();
      this.requestFit();
    }

    updatePageHeaderVar() {
      if (this.sticky === 'none') {
        document.documentElement.style.setProperty('--page-header-height', '0px');
        return;
      }
      var hidden = this.wrap && this.wrap.classList.contains('eys-is-hidden');
      document.documentElement.style.setProperty('--page-header-height', hidden ? '0px' : (this.barH || 0) + 'px');
    }

    isBusy() {
      return !!(this.openItem || this.querySelector('.eys-search.is-open') || (this.drawer && !this.drawer.hidden));
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        var y = window.scrollY;
        var stuck = y > this.uspH + 2;
        if (this.wrap) this.wrap.classList.toggle('eys-is-stuck', stuck);
        if (this.sticky === 'on_scroll_up' && this.wrap) {
          var delta = y - this.lastY;
          var threshold = (this.uspH + this.barH) * 1.2;
          if (delta > 6 && y > threshold && !this.isBusy()) {
            this.wrap.classList.add('eys-is-hidden');
          } else if (delta < -6 || y <= threshold) {
            this.wrap.classList.remove('eys-is-hidden');
          }
        }
        this.updatePageHeaderVar();
        this.lastY = y;
        this.ticking = false;
      });
    }

    onKey(event) {
      if (event.key !== 'Escape') return;
      if (this.drawer && !this.drawer.hidden) {
        this.closeDrawer();
        return;
      }
      if (this.openItem) {
        var toggle = this.openItem.querySelector('[data-eys-mega-toggle]');
        this.closeMega();
        if (toggle) toggle.focus();
      }
    }

    /* Mega menus */
    initMega() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-eys-nav-item]'));
      this.items.forEach((item) => {
        var toggle = item.querySelector('[data-eys-mega-toggle]');
        var link = item.querySelector('[data-eys-mega-link]');
        if (!toggle) {
          item.addEventListener('mouseenter', () => { if (HOVER.matches) this.scheduleClose(0); });
          return;
        }
        item.addEventListener('mouseenter', () => {
          this.warm(item);
          if (HOVER.matches) this.scheduleOpen(item);
        });
        toggle.addEventListener('focus', () => this.warm(item));
        if (link) link.addEventListener('focus', () => this.warm(item));
        item.addEventListener('mouseleave', () => { if (HOVER.matches) this.scheduleClose(); });
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          if (item.classList.contains('is-open')) this.closeMega(); else this.openMega(item);
        });
        if (link) {
          link.addEventListener('click', (e) => {
            /* Touch screens: first tap opens the panel, second tap follows the link */
            if (!HOVER.matches && !item.classList.contains('is-open')) {
              e.preventDefault();
              this.openMega(item);
            }
          });
        }
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) {
            window.setTimeout(() => { if (!item.contains(document.activeElement) && this.openItem === item) this.closeMega(); }, 0);
          }
        });
      });
      var nav = this.querySelector('.eys-nav');
      if (nav) nav.addEventListener('mouseleave', () => { if (HOVER.matches) this.scheduleClose(); });
    }

    /* Mega menu pictures are lazy; start loading them as soon as intent shows so the panel opens complete */
    warm(item) {
      if (!item || item.__eysWarm) return;
      item.__eysWarm = true;
      item.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }

    /* Keep the category row on one line: tighten spacing, then move the last categories into "More" */
    initFit() {
      this.navInner = this.querySelector('.eys-nav__inner');
      this.navList = this.querySelector('.eys-nav__list');
      this.more = this.querySelector('[data-eys-nav-more]');
      this.moreList = this.querySelector('[data-eys-more-list]');
      if (!this.navInner || !this.navList) return;
      this.fitItems = Array.prototype.slice.call(this.navList.querySelectorAll(':scope > [data-eys-nav-item]:not([data-eys-nav-more])'));
      this.fitNav = this.fitNav.bind(this);
      this.fitNav();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.fitNav);
      if ('ResizeObserver' in window) {
        this.fitRo = new ResizeObserver(() => this.requestFit());
        this.fitRo.observe(this.navInner);
      }
    }

    requestFit() {
      if (!this.fitNav || this.fitQueued) return;
      this.fitQueued = true;
      window.requestAnimationFrame(() => { this.fitQueued = false; this.fitNav(); });
    }

    fitNav() {
      if (!this.navList || !DESKTOP.matches) return;
      this.fitOnce();
      this.navInner.classList.add('is-fitted');
    }

    fitOnce() {
      var inner = this.navInner;
      var list = this.navList;
      var overflows = function () { return list.scrollWidth > list.clientWidth + 1; };
      inner.classList.remove('is-compact', 'is-tight');
      this.fitItems.forEach(function (item) { item.classList.remove('is-overflow'); });
      if (this.more) this.more.hidden = true;
      if (!overflows()) return this.renderMore([]);
      inner.classList.add('is-compact');
      if (!overflows()) return this.renderMore([]);
      inner.classList.add('is-tight');
      if (!overflows() || !this.more) return this.renderMore([]);
      this.more.hidden = false;
      var moved = [];
      for (var i = this.fitItems.length - 1; i > 0 && overflows(); i--) {
        this.fitItems[i].classList.add('is-overflow');
        if (this.openItem === this.fitItems[i]) this.closeMega();
        moved.unshift(this.fitItems[i]);
      }
      this.renderMore(moved);
    }

    renderMore(moved) {
      if (!this.moreList) return;
      var key = moved.map(function (item) { return item.dataset.eysUrl; }).join('|');
      if (key === this.moreKey) return;
      this.moreKey = key;
      if (!moved.length && this.openItem === this.more) this.closeMega();
      this.moreList.innerHTML = moved.map(function (item) {
        var count = item.dataset.eysCount ? '<span class="eys-more__count">' + escapeHtml(item.dataset.eysCount) + '</span>' : '';
        return '<li><a href="' + escapeHtml(item.dataset.eysUrl || '#') + '"><span>' + escapeHtml(item.dataset.eysTitle || '') + '</span>' + count + '</a></li>';
      }).join('');
    }

    scheduleOpen(item) {
      clearTimeout(this.closeTimer);
      clearTimeout(this.openTimer);
      var delay = this.openItem ? 40 : 140;
      this.openTimer = setTimeout(() => this.openMega(item), delay);
    }

    scheduleClose(delay) {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.closeMega(), typeof delay === 'number' ? delay : 180);
    }

    openMega(item) {
      clearTimeout(this.closeTimer);
      if (this.openItem && this.openItem !== item) this.setItemState(this.openItem, false);
      this.openItem = item;
      this.setItemState(item, true);
      this.showScrim(true);
    }

    closeMega() {
      clearTimeout(this.openTimer);
      if (!this.openItem) return;
      this.setItemState(this.openItem, false);
      this.openItem = null;
      if (!this.querySelector('.eys-search.is-open')) this.showScrim(false);
    }

    setItemState(item, open) {
      item.classList.toggle('is-open', open);
      var toggle = item.querySelector('[data-eys-mega-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    showScrim(show) {
      if (!this.scrim) return;
      if (show && DESKTOP.matches) {
        this.scrim.hidden = false;
        window.requestAnimationFrame(() => this.scrim.classList.add('is-visible'));
      } else {
        this.scrim.classList.remove('is-visible');
        this.scrim.hidden = true;
      }
    }

    /* Mobile drawer */
    initDrawer() {
      this.burger = this.querySelector('[data-eys-drawer-open]');
      if (!this.drawer || !this.burger) return;
      this.burger.addEventListener('click', () => this.openDrawer());
      this.drawer.querySelectorAll('[data-eys-drawer-close]').forEach((btn) => btn.addEventListener('click', () => this.closeDrawer()));
      if (this.drawerScrim) this.drawerScrim.addEventListener('click', () => this.closeDrawer());
      this.drawer.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
        var focusables = this.drawer.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])');
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      /* Only one accordion open at a time keeps the list short */
      this.drawer.querySelectorAll('details.eys-acc').forEach((d) => {
        d.addEventListener('toggle', () => {
          if (!d.open) return;
          this.drawer.querySelectorAll('details.eys-acc[open]').forEach((other) => { if (other !== d) other.open = false; });
        });
      });
    }

    openDrawer() {
      this.drawer.hidden = false;
      if (this.drawerScrim) this.drawerScrim.hidden = false;
      document.documentElement.classList.add('eys-lock', 'eys-drawer-open');
      this.burger.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => {
        this.drawer.classList.add('is-open');
        if (this.drawerScrim) this.drawerScrim.classList.add('is-visible');
        var close = this.drawer.querySelector('[data-eys-drawer-close]');
        if (close) close.focus();
      });
    }

    closeDrawer() {
      if (!this.drawer || this.drawer.hidden) return;
      this.drawer.classList.remove('is-open');
      if (this.drawerScrim) this.drawerScrim.classList.remove('is-visible');
      document.documentElement.classList.remove('eys-lock', 'eys-drawer-open');
      this.burger.setAttribute('aria-expanded', 'false');
      var done = () => {
        this.drawer.hidden = true;
        if (this.drawerScrim) this.drawerScrim.hidden = true;
      };
      if (REDUCED.matches) done(); else window.setTimeout(done, 280);
      this.burger.focus();
    }

    /* Mobile benefits bar: gentle rotation (off for reduced motion) */
    initUsp() {
      var list = this.usp && this.usp.querySelector('.eys-usp__list');
      if (!list) return;
      var items = list.querySelectorAll('.eys-usp__item');
      if (items.length < 2 || REDUCED.matches) return;
      var index = 0;
      var show = function () {
        items.forEach(function (el, i) { el.classList.toggle('is-current', i === index); });
      };
      list.classList.add('is-rotating');
      show();
      this.uspTimer = setInterval(function () {
        if (DESKTOP.matches || document.hidden) return;
        index = (index + 1) % items.length;
        show();
      }, 4500);
    }
  }

  /* ---------- Predictive search ---------- */
  class EysSearch extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector('[data-eys-search-panel]');
      this.results = this.querySelector('[data-eys-search-results]');
      this.clearBtn = this.querySelector('[data-eys-search-clear]');
      this.recentWrap = this.querySelector('[data-eys-recent]');
      this.recentList = this.querySelector('[data-eys-recent-list]');
      this.header = this.closest('eys-header');
      this.cache = new Map();
      this.activeIndex = -1;
      this.sectionId = this.dataset.sectionId || 'eys-predictive-search';
      if (!this.input || !this.panel) return;

      this.onInput = this.debounce(this.onInput.bind(this), 180);
      this.input.addEventListener('input', () => { this.toggleClear(); this.onInput(); });
      this.input.addEventListener('focus', () => this.open());
      this.input.addEventListener('click', () => this.open());
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.form.addEventListener('submit', () => this.remember(this.input.value));
      if (this.clearBtn) this.clearBtn.addEventListener('click', () => this.clear());
      var recentClear = this.querySelector('[data-eys-recent-clear]');
      if (recentClear) recentClear.addEventListener('click', () => { store.set('eys_recent_searches', []); this.renderRecent(); this.input.focus(); });

      this.panel.addEventListener('click', (e) => {
        var term = e.target.closest('[data-eys-term]');
        if (term) this.remember(term.dataset.eysTerm);
      });

      this.onDocClick = (e) => { if (!this.contains(e.target)) this.close(); };
      document.addEventListener('click', this.onDocClick);
      this.addEventListener('focusout', (e) => {
        if (e.relatedTarget && !this.contains(e.relatedTarget)) this.close();
      });
      if (this.header) this.header.addEventListener('eys:scrim-click', () => this.close());
      window.addEventListener('resize', () => { if (this.classList.contains('is-open')) this.positionPanel(); }, { passive: true });
      this.toggleClear();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }

    debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(null, args); }, wait);
      };
    }

    toggleClear() {
      if (this.clearBtn) this.clearBtn.hidden = this.input.value.length === 0;
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.renderRecent();
      this.classList.add('is-open');
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.positionPanel();
      if (this.header && typeof this.header.showScrim === 'function') {
        this.header.closeMega();
        this.header.showScrim(true);
      }
      if (!DESKTOP.matches) document.documentElement.classList.add('eys-lock');
      if (this.input.value.trim().length >= 2 && !this.classList.contains('has-results')) this.onInput();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.activeIndex = -1;
      if (this.header && typeof this.header.showScrim === 'function' && !this.header.openItem) this.header.showScrim(false);
      if (!document.documentElement.classList.contains('eys-drawer-open')) document.documentElement.classList.remove('eys-lock');
    }

    positionPanel() {
      if (DESKTOP.matches) return;
      var rect = this.form.getBoundingClientRect();
      this.panel.style.setProperty('--eys-search-top', Math.round(rect.bottom + 8) + 'px');
    }

    clear() {
      this.input.value = '';
      this.toggleClear();
      this.showIdle();
      this.input.focus();
    }

    showIdle() {
      this.classList.remove('has-results', 'is-loading');
      this.panel.classList.remove('is-wide');
      this.results.innerHTML = '';
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
    }

    onInput() {
      var q = this.input.value.trim();
      if (q.length < 2) {
        this.showIdle();
        return;
      }
      this.open();
      if (this.cache.has(q)) {
        this.render(this.cache.get(q), q);
        return;
      }
      if (this.controller) this.controller.abort();
      this.controller = 'AbortController' in window ? new AbortController() : null;
      this.classList.add('is-loading');
      var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      var params = [
        'q=' + encodeURIComponent(q),
        'section_id=' + encodeURIComponent(this.sectionId),
        'resources[type]=product,collection,page,query',
        'resources[limit]=8',
        'resources[limit_scope]=each',
        'resources[options][unavailable_products]=last',
        'resources[options][fields]=title,product_type,variants.title,variants.sku,vendor'
      ].join('&');
      fetch(base + '?' + params, { signal: this.controller ? this.controller.signal : undefined, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then((text) => {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var node = doc.querySelector('[data-eys-ps]');
          var html = node ? node.outerHTML : '';
          this.cache.set(q, html);
          if (this.input.value.trim() === q) this.render(html, q);
        })
        .catch((err) => {
          if (err && err.name === 'AbortError') return;
          this.classList.remove('is-loading');
        });
    }

    render(html, q) {
      this.classList.remove('is-loading');
      if (!html) { this.showIdle(); return; }
      this.results.innerHTML = html;
      this.classList.add('has-results');
      this.activeIndex = -1;
      var ps = this.results.querySelector('[data-eys-ps]');
      var hasResults = ps && ps.dataset.hasResults === 'true';
      this.panel.classList.toggle('is-wide', DESKTOP.matches && hasResults);
      this.highlight(q);
      var help = this.results.querySelector('[data-eys-ps-help]');
      if (help && this.header && this.header.dataset.phone) {
        help.innerHTML = 'Still stuck? Call us on <a href="tel:' + escapeHtml(this.header.dataset.phoneHref) + '">' + escapeHtml(this.header.dataset.phone) + '</a> and we’ll help you find it.';
      }
      this.results.querySelectorAll('[data-eys-option] > a').forEach((a) => {
        a.addEventListener('click', () => this.remember(q));
      });
    }

    highlight(q) {
      var words = q.split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      if (!words.length) return;
      var re = new RegExp('(' + words.join('|') + ')', 'gi');
      this.results.querySelectorAll('[data-eys-highlight]').forEach(function (el) {
        el.innerHTML = escapeHtml(el.textContent).replace(re, '<mark>$1</mark>');
      });
    }

    options() {
      return Array.prototype.slice.call(this.results.querySelectorAll('[data-eys-option]'));
    }

    onKeydown(e) {
      if (e.key === 'Escape') {
        if (this.classList.contains('is-open')) { e.stopPropagation(); this.close(); }
        else if (this.input.value) this.clear();
        return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
      var opts = this.options();
      if (e.key === 'Enter') {
        if (this.activeIndex > -1 && opts[this.activeIndex]) {
          var a = opts[this.activeIndex].matches('a') ? opts[this.activeIndex] : opts[this.activeIndex].querySelector('a');
          if (a) { e.preventDefault(); this.remember(this.input.value); window.location.href = a.href; }
        }
        return;
      }
      if (!opts.length) return;
      e.preventDefault();
      this.open();
      if (e.key === 'ArrowDown') this.activeIndex = (this.activeIndex + 1) % opts.length;
      else this.activeIndex = this.activeIndex <= 0 ? opts.length - 1 : this.activeIndex - 1;
      opts.forEach((o, i) => {
        var on = i === this.activeIndex;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var current = opts[this.activeIndex];
      if (current.id) this.input.setAttribute('aria-activedescendant', current.id);
      current.scrollIntoView({ block: 'nearest' });
    }

    remember(term) {
      var t = (term || '').trim();
      if (t.length < 2) return;
      var list = store.get('eys_recent_searches', []).filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); });
      list.unshift(t);
      store.set('eys_recent_searches', list.slice(0, 6));
    }

    renderRecent() {
      if (!this.recentWrap || !this.recentList) return;
      var list = store.get('eys_recent_searches', []);
      if (!list.length) { this.recentWrap.hidden = true; return; }
      var base = (window.routes && window.routes.search_url) || '/search';
      this.recentList.innerHTML = list.map(function (t) {
        return '<li><a class="eys-chip" href="' + base + '?q=' + encodeURIComponent(t) + '&options%5Bprefix%5D=last" data-eys-term="' + escapeHtml(t) + '">' + escapeHtml(t) + '</a></li>';
      }).join('');
      this.recentWrap.hidden = false;
    }
  }

  if (!customElements.get('eys-header')) customElements.define('eys-header', EysHeader);
  if (!customElements.get('eys-search')) customElements.define('eys-search', EysSearch);
})();
